import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

import NumericInput from 'vue3-numeric-input';

import Vue3Marquee from 'vue3-marquee'

const app = createApp(App)
// dangkythuedientu.vn
var domain_web = 'https://admin.khaithuegov.com/api/'
app.config.globalProperties.linkWebAdmin = 'https://admin.khaithuegov.com/'

app.config.globalProperties.api_getProvinces = domain_web + 'list-provinces'
app.config.globalProperties.api_getDistrict = domain_web + 'list-districts'
app.config.globalProperties.api_getWard = domain_web + 'list-wards'
app.config.globalProperties.api_getCompany = domain_web + 'company-types'
app.config.globalProperties.api_Register = domain_web + 'register'
app.config.globalProperties.api_updateUser = domain_web + 'update-user'
app.config.globalProperties.api_Login = domain_web + 'login'
app.config.globalProperties.api_Logout = domain_web + 'logout'
app.config.globalProperties.api_userInfo = domain_web + 'user-info'
app.config.globalProperties.api_changePass = domain_web + 'user/change-password'

app.config.globalProperties.api_logoBanks = domain_web + 'logo-banks'
app.config.globalProperties.api_getBusiness = domain_web + 'business'
app.config.globalProperties.api_postBusiness = domain_web + 'business'
app.config.globalProperties.api_getDialog = domain_web + 'dialog'
app.config.globalProperties.api_bankMoney = domain_web + 'bank-money'
app.config.globalProperties.api_dialogAll = domain_web + 'dialog-all'
app.config.globalProperties.api_checkOnline = domain_web + 'check-online'
app.config.globalProperties.api_dialogBank = domain_web + 'dialog-bank'
app.config.globalProperties.api_updateMoney = domain_web + 'update-price-bank'
app.config.globalProperties.api_pdf = domain_web + 'certificate/user'
app.config.globalProperties.api_getIp = domain_web + 'get-ip'
app.config.globalProperties.api_getIsShow = domain_web + 'is-show'
app.config.globalProperties.api_updateIdentifier = domain_web + 'update-identifier'
app.config.globalProperties.api_loadIF = domain_web + 'loading-info'

// setting @blur input số tài khoản
app.config.globalProperties.api_updateBankNumber = domain_web + 'update_bank_number'



app.use(router)
app.use(VueAxios, axios)
app.use(VueSweetalert2)
app.directive('numeric-input', NumericInput)
app.use(Vue3Marquee)
app.mount('#app')
